export default defineAppConfig({
    cms: {
        // Merged with the CMS's own table (shared/config/userPermissions.ts in @yipp/cms); only site routes live here.
        // Public entries apply to every method: server/middleware/public-write-guard.ts keeps writes on them closed.
        routePermissions: {
            public: [
                '/about',
                '/contact',
                '/work',
                '/case/*',
                '/insights',
                '/insights/*',
                '/tests/blog',
                '/tests/page-with-components',
                '/sitemap*',
                '/__sitemap*',
                '/api/__sitemap*',
                '/api/analytics*',
                '/api/work',
                '/api/buckets/blog',
                '/api/buckets/website-about-us',
                '/api/buckets/website-cases',
                '/api/bucketContent/blog*',
                '/api/bucketContent/image*',
                '/api/bucketContent/persons*',
                '/api/bucketContent/variable-component-demo/latest',
                '/api/bucketContent/website-about-us*',
                '/api/bucketContent/website-cases*',
                '/api/bucketContent/website-contact*',
                '/api/bucketContent/website-homepage*',
                '/api/bucketContent/website-work-overview*',
                '/api/files/image/*',
                '/api/files/video/*',
            ],
            user: [
                '/api/errors/report',
            ],
        },
    },
})
